<template>
  <div>
    <v-card-title>
      Is this a brokerage company?
      <v-checkbox
        hide-details
        class="ml-3"
        :input-value="isBrokerage"
        @change="$emit('update:isBrokerage', $event)"
      />
    </v-card-title>
    <v-card-text v-if="isBrokerage">
      <v-row>
        <v-col cols="12">
          <v-text-field
            label="Legal Entity Name"
            :value="value.legal_name"
            @input="updateField('legal_name', $event)"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="8">
          <v-text-field
            label="Broker License #"
            :value="value.number"
            @input="updateField('number', $event)"
          />
        </v-col>
        <v-col cols="4">
          <StateSelect
            :value="value.state"
            @input="updateField('state', $event)"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field
            label="Tax ID #"
            :value="value.taxId"
            @input="updateField('taxId', $event)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

import { ICompanyBrokerLicense } from '@/bundles/Companies/types';

import StateSelect from '@/bundles/App/components/inputs/StateSelect.vue';

export default Vue.extend({
  name: 'CompanyBrokerageSection',

  components: { StateSelect },

  props: {
    value: {
      type: Object as PropType<ICompanyBrokerLicense>,
      required: true
    },
    isBrokerage: Boolean
  },

  methods: {
    updateField (key: string, value: string) {
      this.$emit('input', { ...this.value, [key]: value });
    }
  }
})
</script>
